const lenis = new Lenis({

  duration: 2.0,

  smoothWheel: true,

  // Mobile ke liye fast + natural
  smoothTouch: false,

  wheelMultiplier: 1.2,

  touchMultiplier: 2,


  prevent: (node) => {

    return node.closest('#CartDrawer, #menu-drawer') !== null;

  }

});




// =========================
// MAIN PAGE RAF
// =========================

function raf(time) {

  lenis.raf(time);

  requestAnimationFrame(raf);

}

requestAnimationFrame(raf);





// ScrollTrigger sync

if (typeof ScrollTrigger !== "undefined") {

  lenis.on("scroll", ScrollTrigger.update);

}





// =========================
// REFRESH FUNCTION
// =========================

function refreshLenis() {


  lenis.resize();


  if (typeof ScrollTrigger !== "undefined") {

    ScrollTrigger.refresh();

  }


}




// Initial refresh

window.addEventListener("load", () => {


  refreshLenis();


  setTimeout(refreshLenis, 500);


  setTimeout(refreshLenis, 1500);


  setTimeout(refreshLenis, 3000);


});





// Resize

window.addEventListener(
  "resize",
  refreshLenis
);





// Shopify Dawn sections

document.addEventListener(
  "shopify:section:load",
  () => {

    setTimeout(refreshLenis,300);

  }
);


document.addEventListener(
  "shopify:section:reorder",
  () => {

    setTimeout(refreshLenis,300);

  }
);





// Images load ke baad height update

document.querySelectorAll("img").forEach((img)=>{


  if(!img.complete){


    img.addEventListener(
      "load",
      refreshLenis
    );


  }


});








// =========================
// DRAWER LENIS
// =========================


let drawerLenisInstances = [];



function initDrawerLenis(){


  const drawers = document.querySelectorAll(

    "#CartDrawer .drawer__inner, #menu-drawer .menu-drawer__inner-container"

  );



  drawers.forEach((drawer)=>{


    if(drawer.dataset.lenisInit) return;


    drawer.dataset.lenisInit = "true";



    const drawerLenis = new Lenis({


      wrapper: drawer,


      content: drawer,


      duration: 1.0,


      smoothWheel: true,


      smoothTouch: false,


      wheelMultiplier: 1,


      touchMultiplier: 1.5


    });




    drawerLenisInstances.push(drawerLenis);




    function drawerRAF(time){


      drawerLenis.raf(time);


      requestAnimationFrame(drawerRAF);


    }


    requestAnimationFrame(drawerRAF);



  });


}





// Drawer open ke baad

document.addEventListener(
  "click",
  ()=>{


    setTimeout(()=>{


      initDrawerLenis();


    },500);


  }
);





// Safety

window.addEventListener(
  "load",
  ()=>{


    setTimeout(()=>{


      initDrawerLenis();


    },1000);


  }
);